import {
  Document,
  PDFViewer,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Loading from "../../components/Loading";
import { getIncentiveRecords } from "../../utils/api";
import { formatDate } from "../../utils/formatData";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 25,
  },
  row: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
    borderLeft: "1px solid #333",
  },
  row2: {
    flexDirection: "row",
    backgroundColor: "white",
    borderLeft: "1px solid #333",
  },
  headingTab: {
    flex: 1,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderTop: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
    backgroundColor: "#fff101",
    fontWeight: "bold",
  },
  headingDateTab: {
    flex: 0.8,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderTop: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
    backgroundColor: "#fff101",
    fontWeight: "bold",
  },
  headingAmountTab: {
    flex: 0.7,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderTop: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
    backgroundColor: "#fff101",
    fontWeight: "bold",
  },
  headingDescTab: {
    flex: 1.5,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderTop: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
    backgroundColor: "#fff101",
    fontWeight: "bold",
  },
  headingCustomerTab: {
    flex: 1,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderTop: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
    backgroundColor: "#fff101",
    fontWeight: "bold",
  },
  headingTypeTab: {
    flex: 0.8,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderTop: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
    backgroundColor: "#fff101",
    fontWeight: "bold",
  },
  headingCompletedByTab: {
    flex: 1,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderTop: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
    backgroundColor: "#fff101",
    fontWeight: "bold",
  },
  cell: {
    flex: 1,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
  cellDate: {
    flex: 0.8,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
  cellAmount: {
    flex: 0.7,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
  cellDesc: {
    flex: 1.5,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
  cellCustomer: {
    flex: 1,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
  cellType: {
    flex: 0.8,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
  cellCompletedBy: {
    flex: 1,
    fontSize: 7.4,
    textAlign: "center",
    borderRight: "1px solid #333",
    borderBottom: "1px solid #333",
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
});

const IncentivePdf = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const user = searchParams.get("user");
  const incentiveType = searchParams.get("incentiveType");

  const getData = async () => {
    setIsLoading(true);
    const [success, response] = await getIncentiveRecords(id);
    if (success) {
      setData(response);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, [id]);

  const getTableData = () => {
    switch (type) {
      case "incentiveCredit":
        return data?.incentiveCreditList || [];
      case "incentivesAmount":
        return data?.incentive || [];
      case "lockedIncentive":
        return data?.incentiveLockedList || [];
      default:
        return [];
    }
  };

  const renderTable = () => {
    const tableData = getTableData();

    switch (type) {
      case "incentiveCredit":
        return (
          <>
            <View style={styles.row}>
              <Text style={styles.headingDateTab}>Date</Text>
              <Text style={styles.headingAmountTab}>Amount</Text>
              <Text style={styles.headingDescTab}>Description</Text>
              <Text style={styles.headingCompletedByTab}>Completed By</Text>
            </View>
            {tableData.map((record, index) => (
              <View key={index} style={styles.row2}>
                <Text style={styles.cellDate}>{formatDate(record?.date)}</Text>
                <Text style={styles.cellAmount}>
                  {record?.amount?.toFixed(2)}
                </Text>
                <Text style={styles.cellDesc}>{record?.description}</Text>
                <Text style={styles.cellCompletedBy}>
                  {record?.completedByName}
                </Text>
              </View>
            ))}
          </>
        );
      case "incentivesAmount":
        return (
          <>
            <View style={styles.row}>
              <Text style={styles.headingDateTab}>Date</Text>

              <Text style={styles.headingCustomerTab}>Customer</Text>
              {type !== "staff" && incentiveType === "Order Incentive" && (
                <Text style={styles.headingTypeTab}>Product</Text>
              )}
              {type !== "staff" && incentiveType === "Order Incentive" && (
                <Text style={styles.headingTypeTab}>Order Quantity</Text>
              )}

              <Text style={styles.headingAmountTab}>Amount</Text>
              <Text style={styles.headingCompletedByTab}>Completed By</Text>
            </View>
            {tableData
              ?.filter((record) => record?.incentiveType === incentiveType)
              ?.map((record, index) => (
                <View key={index} style={styles.row2}>
                  <Text style={styles.cellDate}>
                    {formatDate(record?.createdAt)}
                  </Text>
                  <Text style={styles.cellCustomer}>
                    {record?.customer?.userName ??
                      record?.order?.customer?.userName}
                  </Text>
                  {type !== "staff" && incentiveType === "Order Incentive" && (
                    <Text style={styles.cellType}>
                      {record?.order?.product?.productName}
                    </Text>
                  )}
                  {type !== "staff" && incentiveType === "Order Incentive" && (
                    <Text style={styles.cellType}>
                      {record?.order?.quantity}
                    </Text>
                  )}

                  <Text style={styles.cellAmount}>
                    {record?.amount?.toFixed(2)}
                  </Text>
                  <Text style={styles.cellCompletedBy}>
                    {record?.completedByName}
                  </Text>
                </View>
              ))}
          </>
        );
      case "lockedIncentive":
        return (
          <>
            <View style={styles.row}>
              <Text style={styles.headingDateTab}>Date</Text>
              {user !== "staff" && (
                <Text style={styles.headingCustomerTab}>Customer</Text>
              )}
              <Text style={styles.headingTypeTab}>Type</Text>
              {type !== "staff" && (
                <Text style={styles.headingTypeTab}>Product</Text>
              )}
              {type !== "staff" && (
                <Text style={styles.headingTypeTab}>Order Quantity</Text>
              )}

              <Text style={styles.headingAmountTab}>Pending Amount</Text>
              <Text style={styles.headingCompletedByTab}>Completed By</Text>
            </View>
            {tableData.map((record, index) => (
              <View key={index} style={styles.row2}>
                <Text style={styles.cellDate}>
                  {formatDate(record?.createdAt)}
                </Text>
                {user !== "staff" && (
                  <Text style={styles.cellCustomer}>
                    {record?.customer?.userName ??
                      record?.order?.customer?.userName}
                  </Text>
                )}
                <Text style={styles.cellType}>{record?.incentiveType}</Text>
                {type !== "staff" && (
                  <Text style={styles.cellType}>
                    {record?.order?.product?.productName}
                  </Text>
                )}
                {type !== "staff" && (
                  <Text style={styles.cellType}>{record?.order?.quantity}</Text>
                )}
                <Text style={styles.cellAmount}>
                  {record?.locked?.toFixed(2)}
                </Text>
                <Text style={styles.cellCompletedBy}>
                  {record?.completedByName}
                </Text>
              </View>
            ))}
          </>
        );
      default:
        return null;
    }
  };

  return isLoading ? (
    <Loading />
  ) : (
    <PDFViewer style={{ width: "100%", height: "100vh" }}>
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={{ marginBottom: 20 }}>
            <Text
              style={{ fontSize: 16, marginBottom: 10, textAlign: "center" }}
            >
              {type === "incentiveCredit"
                ? "Incentive Credit"
                : type === "incentivesAmount"
                ? "Incentives Amount"
                : "Locked Incentive"}
              {incentiveType && ` - ${incentiveType}`}
            </Text>
            {renderTable()}
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default IncentivePdf;
